import React from "react"
import Block from "@/components/Block"
import Typography from "@/components/Typography"
import { useTranslation } from "react-i18next"
import MerchantCard from "../components/MerchantCard"
import { useMerchantCardData } from "../hooks/useMerchantCardData"
import Box from "@/components/Box"
import Flex from "@/components/Flex"
import css from "@styled-system/css"
import styled from "@emotion/styled"
import Button from "@/components/Button"
import Link from "@/components/Link"
import { ArrowRight24x14 } from "@/components/Icon"
import { MobileView } from "./MobileView"
import { useUserAgent } from "@/components/hooks/useUserAgent"
import { useSmartScript } from "@/utils/onelink/SmartScriptProvider"

const Container = styled(Box)`
  ${css({
    maxWidth: ["unset", "100vw", null],
    mx: "auto",
    my: 0,
    px: [0, null, 0],
  })}
`

export const GiftCardSection = () => {
  const { t } = useTranslation("payCustomer")
  const { appleGiftCard, starbucksGiftCard, adidasGiftCard, columbiaGiftCard } =
    useMerchantCardData()

  const userAgent = useUserAgent()
  const { oneLinkUrl } = useSmartScript()
  const isIos = userAgent === "ios"
  const isAndroid = userAgent === "android"
  const neitherIosNorAndroid = !isIos && !isAndroid
  const buttonHref = neitherIosNorAndroid
    ? "https://help.crypto.com/en/articles/3073295-crypto-com-gift-cards"
    : oneLinkUrl

  return (
    <Block bg="#FFF">
      <Container>
        <Typography
          maxWidth={[207, "unset"]}
          m="auto"
          mb={4}
          variant="h2"
          as="h2"
          color={"#0B1426"}
          textAlign={"center"}
        >
          {t("newGiftCard.title")}
        </Typography>
        <Box
          maxWidth={"100vw"}
          overflow={"hidden"}
          display={["none", "none", "flex"]}
          customCss={{ gap: 2 }}
          justifyContent={"center"}
        >
          <MerchantCard
            text={t("newGiftCard.startbucks_gift_card")}
            cardStyle={starbucksGiftCard}
            isFixedWidth={true}
          />
          <MerchantCard
            text={t("newGiftCard.apple_gift_card")}
            textColor="#0B1426"
            cardStyle={appleGiftCard}
            isFixedWidth={true}
          />
          <MerchantCard
            text={t("newGiftCard.adidas_gift_card")}
            cardStyle={adidasGiftCard}
            isFixedWidth={true}
          />
        </Box>
        <Box
          overflow={"hidden"}
          display={["none", "flex", "none"]}
          flexDirection={"column"}
          customCss={{ gap: 2 }}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Flex customCss={{ gap: 2 }} mr={"86px"}>
            <MerchantCard
              text={t("newGiftCard.startbucks_gift_card")}
              cardStyle={starbucksGiftCard}
              direction="right"
              isFixedWidth={true}
            />
            <MerchantCard
              text={t("newGiftCard.apple_gift_card")}
              textColor="#0B1426"
              cardStyle={appleGiftCard}
              direction="right"
              isFixedWidth={true}
            />
          </Flex>
          <Flex customCss={{ gap: 2 }} ml={"86px"}>
            <MerchantCard
              text={t("newGiftCard.columbia_gift_card")}
              cardStyle={columbiaGiftCard}
              isFixedWidth={true}
            />
            <MerchantCard
              text={t("newGiftCard.adidas_gift_card")}
              cardStyle={adidasGiftCard}
              isFixedWidth={true}
            />
          </Flex>
        </Box>
        <Box display={["block", "none", "none"]}>
          <MobileView />
        </Box>
        <Flex
          mt={4}
          flexDirection={"column"}
          alignItems={"center"}
          customCss={{ gap: 2 }}
        >
          <Link href={buttonHref}>
            <Button variant="secondaryLight" className="pay-cta-gift-card">
              {t("newGiftCard.button")}
              <ArrowRight24x14 ml={1} fontSize={24} paddingTop={"5px"} />
            </Button>
          </Link>
          <Typography
            variant="p"
            color={"#565F76"}
            fontSize={[14, 14, 18]}
            fontWeight={400}
            lineHeight={"155%"}
          >
            {t("newGiftCard.button_description")}
          </Typography>
        </Flex>
      </Container>
    </Block>
  )
}
